import { render } from "./PlayerTeam-v2.vue?vue&type=template&id=2440b2ea&scoped=true"
import script from "./PlayerTeam-v2.vue?vue&type=script&lang=js"
export * from "./PlayerTeam-v2.vue?vue&type=script&lang=js"

import "./PlayerTeam-v2.vue?vue&type=style&index=0&id=2440b2ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2440b2ea"]])

export default __exports__